<template>
  <!-- ユーザ一括追加 -->
  <div id="AppUserManagementAddUserList">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box">
      <!-- 検索実行ボタン-->
      <div class="columns" style="text-align:center;">
        <div class="column">
          <b-field class="file">
            <b-upload v-model="uploadfile" v-on:input="changeUploadfile">
              <a class="button is-primary">
                <b-icon icon="upload"></b-icon>
                <span>一括登録ファイル読込</span>
              </a>
            </b-upload>
          </b-field>
        </div>
      </div>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
export default {
  name: "AppUserManagementAddUserList",
  methods: {
    changeUploadfile: function() {
      var excuteApi = this.uploadUserFilePOST;
      var successCallBack = this.uploadSuccess;
      var errorCallBack = this.uploadError;
      // WebAPI Call
      this.uploadApiCall(excuteApi, successCallBack, errorCallBack);
    },
    uploadUserFilePOST: function(client) {
      return client.apis.apiMaster.uploadUserFilePOST({
        upfile: this.uploadfile
      });
    },
    uploadSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.showSuccess(result);
      this.uploadfile = null;
    },
    uploadError: function(result) {
      this.showErrorMessage(result);
      this.uploadfile = null;
    }
  },
  data() {
    return {
      uploadfile: null
    };
  },
  components: {}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppUserManagementAddUserList.vue